import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e9d2fa12&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=e9d2fa12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d2fa12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9d2fa12')) {
      api.createRecord('e9d2fa12', component.options)
    } else {
      api.reload('e9d2fa12', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e9d2fa12&scoped=true&", function () {
      api.rerender('e9d2fa12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_RiskScore/index.vue"
export default component.exports